"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sanitizeHtml_1 = require("@/app/shared/helpers/sanitizeHtml");
const outline_1 = require("@heroicons/react/24/outline");
const tooltip_1 = require("primereact/tooltip");
const uuid_1 = require("uuid");
const Tooltip = ({ text }) => {
    const uniqueId = `info-${(0, uuid_1.v4)()}`;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { className: 'max-w-240px', position: 'top', target: `.${uniqueId}`, autoHide: false, children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, sanitizeHtml_1.sanitizeHtml)(text) } }) }), (0, jsx_runtime_1.jsx)(outline_1.InformationCircleIcon, { className: `${uniqueId} icon-16px text-gray-50` })] }));
};
exports.Tooltip = Tooltip;
